import { render, staticRenderFns } from "./visiteVolume.vue?vue&type=template&id=24df0058&"
import script from "./visiteVolume.vue?vue&type=script&lang=js&"
export * from "./visiteVolume.vue?vue&type=script&lang=js&"
import style0 from "./visiteVolume.vue?vue&type=style&index=0&id=24df0058&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports